/* -QA28's door grew with its unit (#3727): the unit went from 550 to 750 mm, growing at its foot. A save from before keeps its door
 * devices' heights up from the old door's foot; each takes the same share of the new door's height, on the door's 5 mm step, so the
 * lamp a fifth of the way down and the buttons half way stay there. Only -QA28's build (ui.build) has the taller door. */
/** The unit's height before and after #3727, metres. */
export const QA28_H = { was: .55, now: .75 };
const step = (z: number) => +(Math.round(z * QA28_H.now / QA28_H.was / .005) * .005).toFixed(4);
const door = (ui: any) => {
  const ps = ui?.build?.placements;
  return Array.isArray(ps) ? { ...ui, build: { ...ui.build, placements: ps.map((p: any) => p?.door && typeof p.z === "number" ? { ...p, z: step(p.z) } : p) } } : ui;
};
/** A saved MCC-001 project ({ model, ui }) with -QA28's door devices at their heights on the 750 mm door, and each earlier attempt it keeps. */
export function doorQa28Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = { ...s, ui: door(s.ui) };
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => ({ ...a, ui: door(a?.ui) })) } : out;
}
